import React from 'react';

import { WindowsIconProps } from '../../types';

/**
 * Windows 图标组件
 * 用于显示 Windows 系统的下载图标
 */
const WindowsIcon: React.FC<WindowsIconProps> = ({
  width = 20,
  height = 20,
  color = '#000000',
  className,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 81 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.7324 42.5318V66.2075L9.90625 62.8166V42.5621H34.7324V42.5318ZM34.7324 15.4955V39.474H9.90625V18.9167L34.7324 15.4955ZM70.4579 42.5318V71.1425L37.4572 66.6011V42.5621H70.4579V42.5318ZM70.4579 10.5908V39.474H37.4572V15.1322L70.4579 10.5908Z"
        fill={color}
      />
    </svg>
  );
};

export default WindowsIcon;
